import { createFileRoute } from '@tanstack/react-router'

import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'
import { LabSettings } from '@/pages/Settings/LabSettings'

export const Route = createFileRoute('/_app/settings/lab')({
  component: LabSettings,
  beforeLoad: ({ context }) => {
    requirePermission(context.permissions, 'write:lab_settings')
  },
  errorComponent: forbiddenErrorComponent,
})
